import React from 'react';
import axios from 'axios';
import moment from "moment";
import moments from 'moment-timezone';
export async function Commonfun(filename, type, ApiToken, domainid) {
  try {
    const apicalldata = await apicallfun(ApiToken, domainid);
    const now = new Date();
    const day = now.getDate();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');

    return `${filename}-${apicalldata}-${day}-${month}-${year}-${hours}-${minutes}-${seconds}.${type}`;
  } catch (error) {
    console.error("Error in Commonfun:", error);
    throw error;
  }
}
export function timezoneval() {
  return moment.tz.guess();
}

export function timezonechange(codejobDate) {
  try {
    var tzs = timezoneval();
    const hasTime = moment(codejobDate).format("HH:mm") !== "00:00";
    let timeVal;
    if (codejobDate) {
      const hasTime = moment(codejobDate).format("HH:mm") !== "00:00";

      timeVal = hasTime
        ? moment.utc(codejobDate).tz(tzs).format("MMMM DD, YYYY hh:mm A")
        : moment().tz(tzs).format("MMMM DD, YYYY hh:mm A");
    } else {
      timeVal = moment().tz(tzs).format("MMMM DD, YYYY hh:mm A");
    }
    return timeVal;
  }
  catch (error) {
    console.error("Error in apicallfun:", error);
    throw error;
  }
}
export async function apicallfun(ApiToken, domainid) {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}domain/get_domain/?user_domain_id=${domainid}`,
      {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
    );

    if (response.data && response.data.queryset_values.length > 0) {
      const replacedString = response.data.queryset_values[0].domain__name.replace(/\s+/g, '-');
      return replacedString;
    } else {
      throw new Error("No data found or invalid response format");
    }
  } catch (error) {
    console.error("Error in apicallfun:", error);
    throw error;
  }
}
export function datezonechange(codejobDate) {
  try {

    var tzs = timezoneval();
    const hasTime = moment(codejobDate).format("HH:mm") !== "00:00";
    let timeVal;
    if (codejobDate) {
      const hasTime = moment(codejobDate).format("HH:mm") !== "00:00";
      timeVal = hasTime
        ? moment.utc(codejobDate).tz(tzs).format("MMMM DD, YYYY")
        : moment().tz(tzs).format("MMMM DD, YYYY");

    } else {
      timeVal = moment().tz(tzs).format("MMMM DD, YYYY");
    }
    return timeVal;
  }
  catch (error) {
    console.error("Error in apicallfun:", error);
    throw error;
  }
}

export function removeDuplicateDate(completeDate) {
  // var completeDate = [
  //   { "id": 12877, "completed_at": "June 05, 2026 08:33" },
  //   { "id": 4721, "completed_at": "April 17, 2026 09:29" },
  //   { "id": 4725, "completed_at": "April 17, 2026 09:09" }
  // ];

  let uniqueByCompletedAt = [];
  completeDate.forEach(cd => {
    const include = uniqueByCompletedAt.find(unique => unique.label === datezonechange(cd.completed_at));
    if (!include) {
      uniqueByCompletedAt.push({ value: cd.id, label: datezonechange(cd.completed_at) })
    }
  })
  return uniqueByCompletedAt;

}